import { ChiliPiperBannerWithContext } from './ChiliPiperBannerWithContext';

export default {
  ReactComponent: ChiliPiperBannerWithContext,
  bindings: {
    currentUser: '<',
    onUpdateClientFlags: '&',
    path: '<',
  },
};
